import React from 'react';
import { Link } from 'react-router-dom';

const ProductCard = ({ product }) => {
  const placeholderImage = 'https://via.placeholder.com/400x300?text=Janvahan+Bike';
  
  return (
    <div className="group bg-white rounded-xl shadow-lg overflow-hidden hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-1">
      {/* Image Container */}
      <div className="relative overflow-hidden h-64 bg-gray-200">
        <img
          src={product.image_url?.startsWith('http') ? product.image_url : `https://janvaahan.com/backend/public${product.image_url}`}
          alt={product.name}
          className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
          onError={(e) => {
            e.target.onerror = null;
            e.target.src = placeholderImage;
          }}
        />
        {/* Badge */}
        <div className="absolute top-4 left-4">
          <span className="bg-red-600 text-white text-xs font-semibold px-3 py-1 rounded-full">
            Electric
          </span>
        </div>
        {/* Quick Specs Overlay */}
        <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black to-transparent p-4 opacity-0 group-hover:opacity-100 transition-opacity">
          <div className="flex justify-around text-white text-sm">
            <div className="text-center">
              <div className="text-lg">⚡</div>
              <div>{product.range || 80} km</div>
            </div>
            <div className="text-center">
              <div className="text-lg">🚀</div>
              <div>{product.top_speed || 75} km/h</div>
            </div>
          </div>
        </div>
      </div>
      
      {/* Content */}
      <div className="p-6">
        <h3 className="text-xl font-bold mb-2 group-hover:text-red-600 transition">
          {product.name}
        </h3>
        <p className="text-gray-500 text-sm mb-2">{product.model}</p>
        <p className="text-2xl font-bold text-red-600 mb-4">{product.price}</p>
        <p className="text-gray-600 text-sm mb-4 line-clamp-2">
          {product.description || 'Experience the future of electric mobility with this high-performance bike.'}
        </p>
        
        {/* Specs */}
        <div className="flex justify-between items-center border-t border-gray-100 pt-4 mb-4">
          <div className="flex items-center space-x-1 text-gray-500 text-sm">
            <span>⚡</span>
            <span>{product.range || 80} km</span>
          </div>
          <div className="flex items-center space-x-1 text-gray-500 text-sm">
            <span>🚀</span>
            <span>{product.top_speed || 75} km/h</span>
          </div>
          <div className="flex items-center space-x-1 text-gray-500 text-sm">
            <span>🔋</span>
            <span>2.5 kWh</span>
          </div>
        </div>
        
        {/* Buttons */}
        <div className="flex space-x-3">
          <Link
            to={`/product/${product.id}`}
            className="flex-1 bg-gray-100 text-gray-700 text-center px-4 py-2 rounded-lg hover:bg-gray-200 transition font-medium"
          >
            Details
          </Link>
          <Link
            to={`/book/${product.id}`}
            className="flex-1 bg-red-600 text-white text-center px-4 py-2 rounded-lg hover:bg-red-700 transition font-medium"
          >
            Book Now
          </Link>
        </div>
      </div>
    </div>
  );
};

export default ProductCard;